import { NpProductPrice } from "src/components/home/NpProductPrice"
import { NpHomePageProductData as NpProductCardData } from "src/components/home/types"
import { ProductDiscountPill } from "src/components/product-list/ProductDiscountPill"
import { ProductPrimaryLink } from "src/components/styled/ProductPrimaryLink"
import { Img } from "src/components/unstyled/Img"
import { ProductLink } from "src/components/unstyled/ProductLink"
import { ProductImageSize, toProductImageCdnUrl } from "src/utilities/productImages"

export type NpProductCarouselItemProps = {
  listId: string
  data: NpProductCardData
}

export const NpProductCarouselItem = ({
  listId,
  data: { product, description, heading: name },
}: NpProductCarouselItemProps) => {
  // for dev testing:
  // product.coupon = { code: "ABC", text: "10%", value: 123 }
  // product.coupon = undefined

  const { available, discount, coupon, regularPrice } = product

  const src = toProductImageCdnUrl(product.image, ProductImageSize.Large)
  const discountPill = available && !!discount && (
    <ProductDiscountPill discount={discount} coupon={coupon} regularPrice={regularPrice} />
  )

  return (
    <div className="embla__slide flex max-h-full min-w-0 shrink-0 grow-0 basis-full flex-col py-3.5 pl-10 sm:basis-111">
      <div className="embla__slide_content relative flex flex-1 flex-col">
        <div className="flex size-full flex-1 flex-col items-center gap-6 overflow-hidden rounded-3xl border py-9">
          <ProductLink
            product={product}
            listId={listId}
            className="flex aspect-square w-100 max-w-full overflow-hidden rounded-3xl"
          >
            <Img src={src} alt="" className="aspect-square size-full object-cover" />
          </ProductLink>

          <div className="flex flex-col items-center gap-4 px-4 text-center leading-normal">
            <ProductLink product={product} listId={listId}>
              <h3 className="font-product m-0 text-lg">{name}</h3>
            </ProductLink>
            <span className="text-lg text-pretty">{description}</span>
            <NpProductPrice product={product} />
          </div>

          <div className="flex flex-1 items-end">
            <ProductPrimaryLink product={product} listId={listId} />
          </div>
        </div>

        {discountPill && (
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 border-x-4 border-white">
            {discountPill}
          </div>
        )}
      </div>
    </div>
  )
}
